export default __webpack_public_path__ + "static/media/alt.58583168.svg";